// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"305":"276dc7516231b62e68ab","524":"f66882dea0d1be83f4bf"}[chunkId] + ".css";
};